import { createContext } from "react";

import { ButtonProps } from "../Button";

type SplitControlContextProps = Pick<ButtonProps, "variant" | "size">;

export const SplitControlContext = createContext<SplitControlContextProps | undefined>(undefined);
SplitControlContext.displayName = "SplitControlContext";
